import EditLocation from "./EditLocation";
import './editLocation.scss';

export default EditLocation;